module.exports = __webpack_public_path__ + "static/media/plus-square.3c8373fc.svg";